// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Utils-module--bx--text-truncate--end--1eGoN";
export var bxTextTruncateFront = "Utils-module--bx--text-truncate--front--1kJrO";
export var container = "Utils-module--container--3koq0";
export var hidden = "Utils-module--hidden--2cb0i";